<template>
  <el-tooltip :enterable="false" :content="tooltip" :disabled="!tooltip" placement="top">
    <el-button class="icon-button-with-badge el-button--icon" :type="type" :disabled="disabled" @click="onClick">
      <Icon :name="name" />
      <div v-if="showBadge" :class="['badge', `badge-${badgeVariant}`]">
        <slot name="badge" />
      </div>
    </el-button>
  </el-tooltip>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'

type TBadgeVariant = 'active' | 'success' | 'warning' | 'danger' | 'twitter'

export default defineComponent({
  name: 'IconButtonWithBadge',
  components: { Icon },
  props: {
    name: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String as PropType<'default' | 'primary'>,
      default: 'default'
    },
    showBadge: {
      type: Boolean,
      default: false
    },
    badgeVariant: {
      type: String as PropType<TBadgeVariant>,
      default: 'active'
    }
  },
  emits: ['click'],
  setup(_props, context) {
    function onClick(event: Event) {
      context.emit('click', event)
    }

    return { onClick }
  }
})
</script>

<style lang="scss" scoped>
.icon-button-with-badge {
  position: relative;
}

.badge {
  right: -4px;
  bottom: 0;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 12px;
  height: 20px;
  padding: 0 4px;
  line-height: 1;

  :deep(.mdi) {
    width: auto;
    height: auto;
    font-size: inherit;
    line-height: inherit;
    vertical-align: middle;
  }
}
</style>
